import {getTimestampCorrelationId, trackPerformanceDataLoad} from '../canvas-timeline/canvas_timeline_performance_track';
import DirectApi from '../../../directApi';
import {fetchDataPromises, isLoadFailure, showHandlerFailureModal, showLoadFailureModal} from '../scheduling_fetch';
import {initializeData} from './CanvasCapacityOverviewDataUtil';
import {hasFeatureFlag} from '../../../forecast-app/shared/util/FeatureUtil';
import {getFetchDates} from '../loading/LoadMoreUtil';

// DATA PROMISES
const getDataPromises = pageComponent => {
	const req = {method: 'POST'};
	let requestUrl = DirectApi.graphqlServerEndpoint('scheduling/capacity_overview');
	requestUrl += `?timestampCorrelationId=${getTimestampCorrelationId()}`;

	req.url = requestUrl;

	if (hasFeatureFlag('incremental_load_more_include_items')) {
		req.body = {
			...getFetchDates(pageComponent),
		};
	}

	return fetchDataPromises([req]);
};

// FETCH DATA
export function fetchData(pageComponent) {
	trackPerformanceDataLoad(getDataPromises(pageComponent))
		.then(dataArray => {
			const data = dataArray[0];

			// initializeData only guards against a missing payload, so the error sentinel
			// would reach `data.persons.forEach` and throw instead of surfacing anything.
			if (isLoadFailure(data)) {
				showLoadFailureModal(data);
				return;
			}

			initializeData(pageComponent, data, false);
		})
		.catch(error => showHandlerFailureModal('scheduling/capacity_overview', error));
}
